import "babel-polyfill"/* 兼容ie浏览器 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import axios from 'axios'
import VueAxios from 'vue-axios'

import { 
  Popover,
  Icon,
  Row,
  Col,
  Input,
  Tree,
  InputNumber,
  Image,
  Checkbox,
  Tabs,
  TabPane,
  Message,
  Dialog,
  Carousel,
  CarouselItem,
  Button,
} from 'element-ui';

Vue.config.productionTip = false

Vue.use(VueAxios, axios)

Vue.use(Popover);
Vue.use(Icon);
Vue.use(Row);
Vue.use(Col);
Vue.use(Tree);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Image);
Vue.use(Checkbox);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Dialog);
Vue.use(Carousel);
Vue.use( CarouselItem);
Vue.use(Button)

Vue.prototype.$message = Message;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
